import BufferOp from "jsts/org/locationtech/jts/operation/buffer/BufferOp";
import GeoJSONReader from "jsts/org/locationtech/jts/io/GeoJSONReader";
import GeoJSONWriter from "jsts/org/locationtech/jts/io/GeoJSONWriter";

const jsts = {
  BufferOp,
  GeoJSONReader,
  GeoJSONWriter,
};

export default jsts;
